
import {translateEnglishRussia} from "~/helpers/translate-english-russia";

export default {
  name: "InputDropDown",

  data: function () {
    return {
      search: "",

      isOpen: false
    }
  },

  computed: {
    citiesList: function () {
      const cities = this.$store.state["city-select"]?.citiesList?.cities || [];
      const search = translateEnglishRussia((this.search || "").toLowerCase());

      return cities.filter((t) => {
        const names = ((t?.name || "").toLowerCase() || "").split(/ |-/);
        return Boolean(names.find((name) => Boolean(name.indexOf(search) === 0)))
      })
    }
  },

  props: {
    value: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },

    required: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    value: function ()  {
      this.search = this.value;
    },
    search: function () {
      this.checkSearch();
    },
  },

  mounted: function () {
    if (this.value) {
      this.search = this.value;
    }
  },

  methods: {
    onFocus: async function () {
      this.isOpen = true;
      await this.getListCities();
    },
    closeDropdown: function ({ isCheckCity } = {}) {
      this.isOpen = false;
      if (isCheckCity) {
        this.checkSearchClose();
      }
    },

    checkSearch: function () {
      const search = (this.search || "").toLowerCase();
      const findCity = this.citiesList.find((t) => (t?.name || "").toLowerCase() === search);
      if (!findCity) {
        return
      }

      const findCities = this.citiesList.filter(((t) => (t?.name || "").toLowerCase().indexOf(search) > -1));
      if (findCities.length > 1) {
        return;
      }

      this.changeCity(findCity);
    },
    checkSearchClose: function () {
      const search = (this.search || "").toLowerCase();
      const findCity = this.citiesList.find(((t) => (t?.name || "").toLowerCase() === search));
      if (!findCity) {
        this.changeCity({ name: this.search });
        return
      }

      this.changeCity(findCity);
    },

    getListCities: async function () {
      if (this.citiesList.length > 0) {
        return
      }

      const response = await this.$api.agent.transport.get('cities').then((res) => {
        return res.data
      }).catch(() => {
        return {}
      });
      this.$store.commit("city-select/setCitiesList", response);
    },

    changeCity: function (city) {
      this.$emit("change", city.name);
      this.closeDropdown({ isCheckCity: false });
    },


    inputFocusSet: function () {
      if (!this.$refs.refInputSearch) {
        setTimeout(() => {
          this.inputFocusSet();
        }, 200)
        return
      }
      this.$refs.refInputSearch.focus();
    }
  }
}
